import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AdminSidebar from "../shared/AdminSidebar";
import "./parametre.css";

const Parametre = ({ budgetData = [] }) => {
  const [budgets, setBudgets] = useState(budgetData);
  const navigate = useNavigate();

  const handleEdit = (budget) => {
    navigate("/ModifierLeBudget", { state: { budget } });
  };

  // Fetch data from the backend
  useEffect(() => {
    const fetchBudgetData = async () => {
      try {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const response = await axios.get(`${baseUrl}/getBudgets.php`);
        console.log("Budget data:", response.data); // Log the API response response
        setBudgets(response.data);
      } catch (error) {
        console.error("Error fetching budgets:", error);
      }
    };

    fetchBudgetData(); // Ensure the function is called
  }, []);

  const handleDuplicate = (budget) => {
    alert(`Dupliquer: ${budget.budget_appellation}`);
    // Logic to duplicate the budget
  };

  const handleDelete = (budget) => {
    if (
      window.confirm(
        `Voulez-vous vraiment supprimer ${budget.budget_appellation} ?`
      )
    ) {
      alert(`Supprimé: ${budget.budget_appellation}`);
      // Logic to delete the budget
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div className="content-param admin-content">
        <h1>Liste des Budgets avec Sections, Groupements, et Catégories</h1>

        <Link to={"/AjouterUnBudget"}>
          <button className="add-budget-btn">+ Ajouter un Budget</button>
        </Link>

        <table className="budgets-table">
          <thead>
            <tr>
              <th>Appellation Budget</th>
              <th>Date de Création</th>
              <th>Nombre de Sections</th>
              <th>Nombre de Groupements</th>
              <th>Nombre de Catégories</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {budgets.length > 0 ? (
              budgets.map((budget, index) => (
                <tr key={index}>
                  <td>{budget.appellation || "N/A"}</td> {/* Use 'appellation' */}
                  <td>{budget.dateCreation || "N/A"}</td> {/* Use 'dateCreation' */}
                  <td>{budget.sections?.length || 0}</td> {/* Use 'sections.length' */}
                  <td>
                    {/* Calculate groupementCount dynamically if needed */}
                    {budget.sections?.reduce((count, section) => count + (section.groupements?.length || 0), 0) || 0}
                  </td>
                  <td>
                    {/* Calculate categorieCount dynamically if needed */}
                    {budget.sections?.reduce(
                      (count, section) =>
                        count +
                        (section.groupements?.reduce(
                          (subCount, groupement) => subCount + (groupement.categories?.length || 0),
                          0
                        ) || 0),
                      0
                    ) || 0}
                  </td>
                  <td>
                    <button
                      className="action-btn edit-btn"
                      onClick={() => handleEdit(budget)}
                    >
                      Modifier
                    </button>
                    <button
                      className="action-btn duplicate-btn"
                      onClick={() => handleDuplicate(budget)}
                    >
                      Dupliquer
                    </button>
                    <button
                      className="action-btn delete-btn"
                      onClick={() => handleDelete(budget)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">Aucun budget trouvé.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Parametre;
